module.exports = __webpack_public_path__ + "static/media/iphone6-2up-blank.2a0374fd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/smartphone/iphone6/iphone6-2up-blank.pdf
// module id = 32
// module chunks = 0